import type { State } from "components/Signup/store/state/types";
import { isSessionStorageAvailable } from "utils/utils";

export const stateStore = {
  save: (signUpState: any): void => {
    if (!isSessionStorageAvailable()) {
      return;
    }

    if (
      JSON.stringify(signUpState) !==
      window.sessionStorage.getItem("signUpState")
    )
      window.sessionStorage.setItem(
        "signUpState",
        JSON.stringify({ ...signUpState })
      );
  },

  load: (): State | undefined => {
    const state = isSessionStorageAvailable()
      ? JSON.parse(window.sessionStorage.getItem("signUpState") as string)
      : undefined;

    return state;
  },

  remove: (): void => {
    if (isSessionStorageAvailable()) {
      window.sessionStorage.removeItem("signUpState");
    }
  },
};
